import DepartmentContacts from "@/components/DepartmentContacts.vue";

export const departmentContactsInit = {
    component: DepartmentContacts,
    name: "Department Contacts",
    inputs: [
        {
            name: 'departments',
            friendlyName: 'Departments',
            type: 'array',
            subFields: [
                {
                    name: 'title',
                    friendlyName: 'Title',
                    type: 'string',
                },
                {
                    name: 'contacts',
                    friendlyName: 'Contacts',
                    type: 'array',
                    subFields: [
                        {
                            name: 'title',
                            friendlyName: 'Title',
                            type: 'string',
                        },
                        {
                            name: 'email',
                            friendlyName: 'Email',
                            type: 'string',
                        }
                    ]
                }
            ]
        },
        
    ]
}